module.exports = __webpack_public_path__ + "img/team_banner.abb0ce0a.png";